import React from 'react';

/** Shows the Roblox Loading indicator/spinner
 *  This should be kept largely in sync with moderation portal. See:
 *  Roblox.ModerationPortal.WebApp's ImageWithSpinner.tsx */
const Spinner: React.FC<{ size?: 'default' | 'sm' }> = ({ size = 'default' }) => {
  return (
    <span role='progressbar' aria-label='Loading content' className={`spinner spinner-${size}`} />
  );
};

export default Spinner;
